(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-review-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-review-gallery')) {
    customElements.define('bt-review-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const theme = window.Shopify?.theme;
        if (!window.Shopify?.designMode && !(String(theme?.id) === this.dataset.themeId && theme?.role === 'unpublished')) return;
        this.ready = true;
        this.hidden = false;
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.grid = this.querySelector('[data-grid]');
        this.dialog = this.querySelector('dialog');
        this.limit = Number(this.dataset.initial) || 8;
        this.tab = 'product';
        this.querySelector('[data-product-count]').textContent = this.cards.filter(c => c.dataset.kind === 'product').length;
        this.querySelector('[data-store-count]').textContent = this.cards.filter(c => c.dataset.kind === 'store').length;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-tab')) {
            this.tab = button.dataset.tab;
            this.querySelectorAll('[data-tab]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
            this.limit = Number(this.dataset.initial);
            this.render();
          }
          if (button.hasAttribute('data-open')) this.openReview(button.closest('[data-card]'), button);
          if (button.hasAttribute('data-close')) this.dialog.close();
          if (button.hasAttribute('data-more')) { this.limit += Number(this.dataset.initial); this.render(); }
          if (button.hasAttribute('data-reset')) {
            this.querySelector('[data-rating]').value = 'all';
            this.querySelector('[data-media]').value = 'all';
            this.querySelector('[data-sort]').value = 'newest';
            this.limit = Number(this.dataset.initial);
            this.render();
          }
          if (button.hasAttribute('data-next')) this.showDetail(this.activeIndex + 1);
          if (button.hasAttribute('data-prev')) this.showDetail(this.activeIndex - 1);
        }, options);
        this.addEventListener('change', event => {
          if (!event.target.matches('select')) return;
          this.limit = Number(this.dataset.initial);
          this.render();
        }, options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' && this.activeIndex < this.visibleCards.length - 1) { event.preventDefault(); this.showDetail(this.activeIndex + 1); }
          if (event.key === 'ArrowLeft' && this.activeIndex > 0) { event.preventDefault(); this.showDetail(this.activeIndex - 1); }
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow ?? '';
          this.opener?.focus({ preventScroll: true });
        }, options);
        this.render();
      }
      disconnectedCallback() {
        if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.previousOverflow ?? ''; }
        this.controller?.abort();
        this.ready = false;
      }
      render() {
        const selected = this.cards.filter(c => c.dataset.kind === this.tab);
        const rating = this.querySelector('[data-rating]').value;
        const media = this.querySelector('[data-media]').value;
        const sort = this.querySelector('[data-sort]').value;
        const filtered = selected.filter(c => (rating === 'all' || c.dataset.rating === rating) && (media === 'all' || c.dataset.media === media));
        filtered.sort((a, b) => sort === 'highest' ? Number(b.dataset.rating) - Number(a.dataset.rating) : sort === 'lowest' ? Number(a.dataset.rating) - Number(b.dataset.rating) : b.dataset.date.localeCompare(a.dataset.date));
        this.cards.forEach(c => { c.hidden = true; });
        this.visibleCards = filtered.slice(0, this.limit);
        this.visibleCards.forEach(c => { this.grid.append(c); c.hidden = false; });
        this.querySelector('[data-average]').textContent = selected.length ? (selected.reduce((sum, c) => sum + Number(c.dataset.rating), 0) / selected.length).toFixed(1) : '—';
        this.querySelector('[data-total]').textContent = `${selected.length} ${this.labels.reviews}`;
        this.querySelector('[data-status]').textContent = `${this.labels.showing} ${this.visibleCards.length} ${this.labels.of} ${filtered.length}`;
        this.querySelector('[data-empty]').hidden = filtered.length > 0;
        this.querySelector('[data-more]').hidden = this.limit >= filtered.length;
      }
      openReview(card, opener) {
        this.opener = opener;
        this.querySelector('details').open = false;
        this.showDetail(this.visibleCards.indexOf(card));
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.querySelector('[data-close]').focus();
      }
      showDetail(index) {
        const card = this.visibleCards[index];
        if (!card) return;
        this.activeIndex = index;
        this.querySelector('[data-dialog-content]').replaceChildren(card.querySelector('template').content.cloneNode(true));
        this.querySelector('[data-position]').textContent = `${index + 1} / ${this.visibleCards.length}`;
        this.querySelector('[data-prev]').disabled = index === 0;
        this.querySelector('[data-next]').disabled = index === this.visibleCards.length - 1;
        this.dialog.scrollTop = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-review-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ds-review-gallery')) {
  customElements.define('ds-review-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (this.dataset.shop !== 'xveeka-mt.myshopify.com') { this.hidden = true; return; }
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.storeVerified = new Set(JSON.parse(this.querySelector('[data-store-verified]').textContent));
      this.grid = this.querySelector('[data-grid]');
      this.dialog = this.querySelector('dialog');
      this.measuredCards = new WeakMap();
      this.masonryObserver = new ResizeObserver(entries => {
        let changed = false;
        for (const entry of entries) {
          if (entry.target === this.grid) {
            if (Math.abs((this.gridWidth || 0) - entry.contentRect.width) > 0.5) changed = true;
          } else {
            const previous = this.measuredCards.get(entry.target);
            const size = `${entry.contentRect.width}:${entry.contentRect.height}`;
            if (previous !== size) { this.measuredCards.set(entry.target, size); changed = true; }
          }
        }
        if (changed) this.scheduleMasonry();
      });
      this.size = Math.max(4, Number(this.dataset.initial) || 8);
      this.limit = this.size;
      this.tab = 'product';
      this.scope = this.dataset.context === 'product' && this.dataset.productId ? 'product' : 'all';
      this.overallCount = Number(this.dataset.overallCount) || 0;
      this.overallRating = Number(this.dataset.overallRating) || 0;
      this.storeCount = Number(this.dataset.storeCount) || 0;
      this.storeRating = Number(this.dataset.storeRating) || 0;
      this.productCount = Math.max(0, this.overallCount - this.storeCount);
      this.productRating = 0;
      this.generation = 0;
      this.cache = new Map();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-ds-store-rating]');
        if (!link || link.hash !== `#${this.id}` || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        clearTimeout(this.ratingScrollTimer);
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
        // Sections above can grow after entering the viewport; align once after their lazy layout settles.
        this.ratingScrollTimer = setTimeout(() => {
          if (this.isConnected && this.getBoundingClientRect().top > 300) this.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, 500);
      }, { ...options, capture: true });
      for (const type of ['wheel', 'touchstart', 'keydown']) window.addEventListener(type, () => clearTimeout(this.ratingScrollTimer), { ...options, passive: true });
      this.filters = { sort: 'featured', rating: 'all', media: this.dataset.mediaDefault || 'all' };
      this.filterMenu = this.querySelector('details');
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-filter')) {
          this.filters[button.dataset.filter] = button.dataset.value;
          this.closeFilters();
          this.load(true);
        }
        if (button.hasAttribute('data-tab')) {
          if (this.tab === button.dataset.tab) return;
          this.tab = button.dataset.tab;
          this.querySelectorAll('[data-tab]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          this.filters.media = this.tab === 'store' ? 'all' : (this.dataset.mediaDefault || 'all');
          this.load(true);
        }
        if (button.hasAttribute('data-open')) this.openReview(button.closest('[data-card]').dataset.id, button);
        if (button.hasAttribute('data-close')) this.dialog.close();
        if (button.hasAttribute('data-more')) { this.limit += this.size; this.load(false); }
        if (button.hasAttribute('data-reset')) {
          this.filters.rating = 'all';
          this.filters.media = 'all';
          this.filters.sort = 'featured';
          this.closeFilters();
          this.load(true);
        }
        if (button.hasAttribute('data-retry')) { this.cache.clear(); this.load(true); }
        if (button.hasAttribute('data-next')) this.showDetail(this.activeIndex + 1);
        if (button.hasAttribute('data-prev')) this.showDetail(this.activeIndex - 1);
        if (button.hasAttribute('data-photo')) {
          const review = this.visibleReviews[this.activeIndex];
          const url = review.photos[Number(button.dataset.photo)];
          if (url) {
            this.querySelector('.dsr__modal-image').src = url;
            this.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          }
        }
      }, options);
      document.addEventListener('click', event => {
        if (this.filterMenu.open && !this.filterMenu.contains(event.target)) this.filterMenu.open = false;
      }, options);
      this.filterMenu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.filterMenu.open) { event.preventDefault(); this.closeFilters(); }
      }, options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' && this.activeIndex < this.visibleReviews.length - 1) { event.preventDefault(); this.showDetail(this.activeIndex + 1); }
        if (event.key === 'ArrowLeft' && this.activeIndex > 0) { event.preventDefault(); this.showDetail(this.activeIndex - 1); }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.dialog.querySelectorAll('video').forEach(v => v.pause());
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.opener?.focus({ preventScroll: true });
      }, options);
      this.updateSummary();
      this.load(true);
    }
    disconnectedCallback() {
      this.generation++;
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.previousOverflow ?? ''; }
      this.controller?.abort();
      this.requestController?.abort();
      this.masonryObserver?.disconnect();
      cancelAnimationFrame(this.masonryFrame);
      clearTimeout(this.ratingScrollTimer);
      this.ready = false;
    }
    async fetchData(path, params, signal) {
      const url = new URL(`https://cdn.judge.me/reviews/${path}`);
      url.search = new URLSearchParams({ shop_domain: this.dataset.shop, platform: 'shopify', widget_type: 'review-widget', widget_theme: 'align', ...params });
      if (this.cache.has(url.href)) return this.cache.get(url.href);
      const cacheKey = `dsr:v1:${url.href}`;
      try {
        const saved = JSON.parse(sessionStorage.getItem(cacheKey));
        if (saved && Date.now() - saved.time < 120000 && Array.isArray(saved.data?.reviews) && saved.data.pagination) {
          this.cache.set(url.href, saved.data);
          return saved.data;
        }
        sessionStorage.removeItem(cacheKey);
      } catch {}
      for (let attempt = 0; attempt < 2; attempt++) {
        try {
          const timeout = AbortSignal.timeout(12000);
          const response = await fetch(url, { credentials: 'omit', signal: AbortSignal.any([signal, timeout]), headers: { Accept: 'application/json' } });
          if (!response.ok) {
            const error = new Error(`Review source HTTP ${response.status}`);
            error.retryable = response.status >= 500 || response.status === 408;
            throw error;
          }
          const data = await response.json();
          if (!Array.isArray(data.reviews) || !data.pagination) throw new Error('Unexpected review response');
          this.cache.set(url.href, data);
          try {
            sessionStorage.setItem(cacheKey, JSON.stringify({ time: Date.now(), data }));
          } catch {}
          return data;
        } catch (error) {
          if (signal.aborted || attempt === 1 || !(error.retryable || error instanceof TypeError || error.name === 'TimeoutError')) throw error;
          await new Promise(resolve => setTimeout(resolve, 350));
        }
      }
    }
    closeFilters() {
      this.filterMenu.open = false;
      this.filterMenu.querySelector('summary').focus({ preventScroll: true });
    }
    syncFilters() {
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(this.filters[button.dataset.filter] === button.dataset.value)));
      this.filterMenu.classList.toggle('dsr__filters--active', this.filters.sort !== 'featured' || this.filters.rating !== 'all' || this.filters.media !== 'all');
    }
    async load(reset) {
      this.syncFilters();
      const generation = ++this.generation;
      this.requestController?.abort();
      this.requestController = new AbortController();
      const signal = this.requestController.signal;
      if (reset) {
        this.limit = this.size;
        this.records = [];
        this.nextPage = 1;
        this.totalPages = 1;
        this.filteredTotal = null;
        this.streamPhase = null;
        this.overallPageLoaded = false;
        this.masonryObserver.disconnect();
        this.grid.replaceChildren();
        this.grid.style.height = '0px';
      }
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[data-more]').disabled = true;
      this.querySelector('[data-error]').hidden = true;
      this.querySelector('[data-empty]').hidden = true;
      this.querySelector('[data-status]').textContent = this.labels.loading;
      try {
        if (this.scope === 'product' && !this.productChecked) {
          const base = await this.fetchData('reviews_for_widget', { product_id: this.dataset.productId, page: 1, sort_by: 'created_at', sort_dir: 'desc' }, signal);
          if (generation !== this.generation) return;
          this.productChecked = true;
          this.productCount = Number(base.number_of_reviews) || 0;
          this.productRating = Number(base.average_rating) || 0;
          if (this.productCount === 0) { this.scope = 'all'; this.fallback = true; this.productCount = Math.max(0, this.overallCount - this.storeCount); }
        }
        const rating = this.filters.rating;
        const media = this.filters.media;
        const sort = this.filters.sort;
        const params = { sort_by: ['featured', 'newest'].includes(sort) ? 'created_at' : 'rating', sort_dir: sort === 'lowest' ? 'asc' : 'desc' };
        if (rating !== 'all') params.filter_rating = rating;
        if (media === 'photo') params.show_media_only = 'true';
        if (this.tab === 'store') params.review_type = 'shop-reviews';
        else if (this.scope === 'product') params.product_id = this.dataset.productId;
        const path = this.tab === 'product' && this.scope === 'product' ? 'reviews_for_widget' : 'all_reviews_js_based';
        this.photoFirst = media === 'all' && sort === 'featured';
        if (this.streamPhase === null) this.streamPhase = this.photoFirst ? 'photos' : 'all';
        let countsRequest;
        if (this.photoFirst && !this.overallPageLoaded) {
          if (rating === 'all') this.filteredTotal = this.tab === 'store' ? this.storeCount : this.productCount;
          countsRequest = this.fetchData(path, { ...params, page: 1 }, signal).then(overall => {
            if (generation !== this.generation) return;
            this.updateSourceCounts(overall, rating === 'all');
            this.overallPageLoaded = true;
          }).catch(() => {});
        }
        let requests = 0;
        while (this.records.length < this.limit && requests < 5) {
          if (this.nextPage > this.totalPages) {
            if (this.photoFirst && this.streamPhase === 'photos') {
              this.streamPhase = 'text';
              this.nextPage = 1;
              this.totalPages = 1;
            } else break;
          }
          requests++;
          const streamParams = { ...params, page: this.nextPage };
          if (this.photoFirst && this.streamPhase === 'photos') streamParams.show_media_only = 'true';
          const data = await this.fetchData(path, streamParams, signal);
          if (generation !== this.generation) return;
          if (!this.photoFirst || this.streamPhase === 'text') this.updateSourceCounts(data, rating === 'all' && media === 'all');
          const pagination = data.pagination;
          this.totalPages = Math.max(0, Number(pagination.total_pages) || 0);
          this.nextPage = (Number(pagination.current_page) || this.nextPage) + 1;
          const existing = new Set(this.records.map(r => r.id));
          for (const item of data.reviews) {
            const review = this.normalize(item);
            if (!review || existing.has(review.id)) continue;
            if (this.photoFirst && (this.streamPhase === 'photos') !== (review.photos.length > 0)) continue;
            if ((this.tab === 'store') !== review.isStore) continue;
            if (this.scope === 'product' && this.tab === 'product' && review.productPath && review.productPath !== this.dataset.productPath) continue;
            this.records.push(review);
            existing.add(review.id);
          }
        }
        if (generation !== this.generation) return;
        this.render();
        this.dataset.loaded = 'true';
        if (countsRequest) {
          await countsRequest;
          if (generation !== this.generation) return;
          this.updateSummary();
          this.querySelector('[data-status]').textContent = `${this.labels.showing} ${this.visibleReviews.length}${this.filteredTotal === null ? '' : ` ${this.labels.of} ${this.filteredTotal}`}`;
        }
      } catch (error) {
        if (generation !== this.generation || signal.aborted) return;
        this.querySelector('[data-error]').hidden = false;
        this.querySelector('[data-status]').textContent = '';
        this.querySelector('[data-more]').hidden = true;
        this.dataset.loaded = 'error';
      } finally {
        if (generation === this.generation) { this.removeAttribute('aria-busy'); this.querySelector('[data-more]').disabled = false; }
      }
    }
    updateSourceCounts(data, unfiltered) {
      if (data.number_of_shop_reviews !== undefined) this.storeCount = Number(data.number_of_shop_reviews);
      if (data.number_of_product_reviews !== undefined && this.scope === 'all') this.productCount = Number(data.number_of_product_reviews);
      if (this.scope === 'all' && data.number_of_product_reviews !== undefined) this.overallCount = Number(data.number_of_product_reviews) + Number(data.number_of_shop_reviews || 0);
      if (data.pagination.total_count !== undefined) this.filteredTotal = Number(data.pagination.total_count);
      else if (unfiltered && data.number_of_reviews !== undefined) this.filteredTotal = Number(data.number_of_reviews);
    }
    normalize(item) {
      if (!item.uuid || !(Number(item.rating) >= 1 && Number(item.rating) <= 5)) return null;
      const media = Array.isArray(item.pictures_urls) ? item.pictures_urls : [];
      const photos = media.map(p => this.safeURL(typeof p === 'string' ? p : p.huge || p.original)).filter(Boolean);
      const productURL = this.safeURL(item.product_url, true);
      const imported = (item.transparency_badges || []).includes('review_collected_from_another_provider') || ['csv', 'import', 'imported'].includes(item.source);
      const merchantVerified = imported || this.storeVerified.has(String(item.uuid));
      return {
        id: String(item.uuid), author: String(item.reviewer_name || 'Anonymous'), title: String(item.title || ''),
        text: item.body ? String(item.body) : new DOMParser().parseFromString(String(item.body_html || ''), 'text/html').body.textContent, rating: Number(item.rating), date: String(item.created_at || ''),
        verified: item.verified_buyer === true || merchantVerified, verifiedBy: item.verified_buyer === true ? 'judgeme' : merchantVerified ? 'store' : '', imported, isStore: item.is_shop_review === true,
        photos, productURL: item.product_in_store !== false ? productURL : '', productPath: productURL ? new URL(productURL, location.origin).pathname : '',
        productTitle: String(item.product_title_localized || item.product_title || ''), productImage: this.safeURL(item.product_variant_image_url || item.product_pictures_url),
        reply: item.reply_content ? new DOMParser().parseFromString(String(item.reply_content), 'text/html').body.textContent : ''
      };
    }
    safeURL(value, product = false) {
      if (typeof value !== 'string' || !value) return '';
      try {
        const url = new URL(value, location.origin);
        if (url.protocol !== 'https:') return '';
        if (product && (url.origin !== location.origin || !url.pathname.startsWith('/products/'))) return '';
        return product ? url.pathname : url.href;
      } catch { return ''; }
    }
    element(tag, cls, text) {
      const e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text !== undefined) e.textContent = text;
      return e;
    }
    image(url, cls, alt) {
      const image = this.element('img', cls);
      image.src = url;
      image.alt = alt;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', () => { image.hidden = true; });
      return image;
    }
    identity(review, modal = false) {
      const row = this.element('div', 'dsr__identity');
      row.append(this.element(modal ? 'h3' : 'strong', '', review.author));
      if (review.verified) {
        const badge = this.element('span', 'dsr__verified');
        badge.setAttribute('aria-label', this.labels.verified);
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 20 20');svg.setAttribute('aria-hidden', 'true');
        const circle = document.createElementNS(svg.namespaceURI, 'circle');circle.setAttribute('cx','10');circle.setAttribute('cy','10');circle.setAttribute('r','10');circle.setAttribute('fill','currentColor');
        const path = document.createElementNS(svg.namespaceURI,'path');path.setAttribute('d','M5.5 10l3 3 6-6');path.setAttribute('fill','none');path.setAttribute('stroke','#fff');path.setAttribute('stroke-width','1.8');path.setAttribute('stroke-linecap','round');path.setAttribute('stroke-linejoin','round');
        svg.append(circle,path);badge.append(svg,this.element('span','dsr__verified-label',this.labels.verified));row.append(badge);
      }
      return row;
    }
    stars(review) {
      const stars = this.element('span','dsr__stars');
      stars.setAttribute('aria-label', this.labels.out_of_five.replace('__count__',String(review.rating)));
      for(let i=1;i<=5;i++){const star=this.element('span',i>review.rating?'dsr__star-empty':'','★');star.setAttribute('aria-hidden','true');stars.append(star);}
      return stars;
    }
    date(review) {
      const time=this.element('time','dsr__date');const date=new Date(review.date);
      if(!Number.isNaN(date.getTime())){time.dateTime=date.toISOString();time.textContent=new Intl.DateTimeFormat(document.documentElement.lang||'en',{year:'numeric',month:'short',day:'numeric',timeZone:'UTC'}).format(date);}
      return time;
    }
    imported(review) {
      if(!review.imported)return null;
      const label=this.element('span','dsr__imported',this.labels.imported);label.title=this.labels.imported_hint;return label;
    }
    productLink(review, modal = false) {
      if(review.isStore||!review.productURL)return null;
      const a=this.element('a',`dsr__product${modal?' dsr__product--modal':''}`);a.href=review.productURL;
      if(review.productImage)a.append(this.image(review.productImage,'dsr__product-image',review.productTitle));
      const text=this.element('span','',review.productTitle);
      if(modal)text.append(this.element('span','dsr__view-product',this.labels.view_product+' →'));
      a.append(text);return a;
    }
    card(review) {
      const card=this.element('article','dsr__card');card.dataset.card='';card.dataset.id=review.id;card.dataset.rating=review.rating;card.dataset.verified=String(review.verified);card.dataset.verifiedBy=review.verifiedBy;card.dataset.imported=String(review.imported);card.dataset.productPath=review.productPath;card.dataset.kind=review.isStore?'store':'product';
      const openLabel=this.labels.open_review.replace('__name__',review.author);
      if(review.photos.length){const button=this.element('button','dsr__photo');button.type='button';button.dataset.open='';button.setAttribute('aria-label',openLabel);button.style.setProperty('--dsr-ratio','3 / 4');button.append(this.image(review.photos[0],'dsr__image',review.productTitle||review.author));card.append(button);}
      const body=this.element('div','dsr__body');const button=this.element('button','dsr__review-button');button.type='button';button.dataset.open='';button.setAttribute('aria-label',openLabel);
      button.append(this.identity(review),this.date(review),this.stars(review));
      if(review.title)button.append(this.element('span','dsr__review-title',review.title));
      const text=this.element('span','dsr__text',review.text);text.style.whiteSpace='pre-line';button.append(text);body.append(button);
      const product=this.productLink(review);if(product)body.append(product);
      card.append(body);return card;
    }
    updateSummary() {
      const isProduct=this.tab==='product'&&this.scope==='product';
      const rating=this.tab==='store'?this.storeRating:isProduct?this.productRating:this.overallRating;
      const count=this.tab==='store'?this.storeCount:isProduct?this.productCount:this.overallCount;
      this.querySelector('[data-average]').textContent=rating>0?rating.toFixed(1):'—';
      this.querySelector('.dsr__stars--large').style.setProperty('--dsr-fill',`${Math.min(100,Math.max(0,rating*20))}%`);
      this.querySelector('[data-total]').textContent=`${count} ${this.labels.reviews}`;
      this.querySelector('.dsr__summary').title=isProduct?this.labels.this_product:this.labels.overall_rating;
      this.querySelector('[data-product-count]').textContent=this.productCount;
      this.querySelector('[data-store-count]').textContent=this.storeCount;
      this.querySelector('[data-product-label]').textContent=this.fallback?this.labels.across_store:this.labels.product_reviews;
      this.querySelector('[data-scope-note]').textContent=this.tab==='store'?this.labels.store_scope:this.fallback?this.labels.fallback_note:this.scope==='product'?this.labels.this_product:this.labels.across_store;
    }
    scheduleMasonry() {
      cancelAnimationFrame(this.masonryFrame);
      this.masonryFrame = requestAnimationFrame(() => { if (this.isConnected) this.layoutMasonry(); });
    }
    layoutMasonry() {
      const style = getComputedStyle(this.grid);
      const columns = Math.max(1, parseInt(style.getPropertyValue('--dsr-cols'), 10) || 4);
      const gap = parseFloat(style.columnGap) || 12;
      const width = this.grid.clientWidth;
      if (!width) return;
      this.gridWidth = width;
      const cardWidth = (width - gap * (columns - 1)) / columns;
      this.grid.style.setProperty('--dsr-card-width', `${cardWidth}px`);
      const cards = Array.from(this.grid.querySelectorAll('[data-card]'));
      const heights = cards.map(card => card.getBoundingClientRect().height);
      const offsets = Array(columns).fill(0);
      cards.forEach((card, index) => {
        const column = offsets.indexOf(Math.min(...offsets));
        card.style.left = `${column * (cardWidth + gap)}px`;
        card.style.top = `${offsets[column]}px`;
        offsets[column] += heights[index] + gap;
      });
      this.grid.style.height = `${Math.max(0, ...offsets) - (cards.length ? gap : 0)}px`;
    }
    render() {
      this.visibleReviews=this.records.slice(0,this.limit);
      this.masonryObserver.disconnect();
      this.grid.classList.add('dsr__grid--masonry');
      this.grid.replaceChildren(...this.visibleReviews.map(r=>this.card(r)));
      this.layoutMasonry();
      this.masonryObserver.observe(this.grid);
      this.grid.querySelectorAll('[data-card]').forEach(card => this.masonryObserver.observe(card));
      this.updateSummary();
      this.querySelector('[data-empty]').hidden=this.visibleReviews.length>0;
      this.querySelector('[data-status]').textContent=`${this.labels.showing} ${this.visibleReviews.length}${this.filteredTotal===null?'':` ${this.labels.of} ${this.filteredTotal}`}`;
      this.querySelector('[data-more]').hidden=this.records.length<=this.limit&&((this.filteredTotal!==null&&this.records.length>=this.filteredTotal)||(this.nextPage>this.totalPages&&!(this.photoFirst&&this.streamPhase==='photos')));
    }
    openReview(id, opener) {
      this.opener=opener;this.filterMenu.open=false;
      this.showDetail(this.visibleReviews.findIndex(r=>r.id===id));
      this.previousOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';this.querySelector('[data-close]').focus();
    }
    showDetail(index) {
      const review=this.visibleReviews[index];if(!review)return;this.activeIndex=index;
      const content=this.querySelector('[data-dialog-content]');content.replaceChildren();
      if(review.photos.length){const media=this.element('div','dsr__modal-media');media.append(this.image(review.photos[0],'dsr__modal-image',review.productTitle||review.author));content.append(media);}
      const copy=this.element('div','dsr__modal-copy');copy.append(this.identity(review,true),this.stars(review),this.date(review));
      if(review.title)copy.append(this.element('strong','dsr__review-title',review.title));
      const text=this.element('p','dsr__full-text',review.text);text.style.whiteSpace='pre-line';copy.append(text);
      if(review.photos.length>1){const thumbs=this.element('div','dsr__media-thumbs');review.photos.forEach((url,i)=>{const button=this.element('button');button.type='button';button.dataset.photo=i;button.setAttribute('aria-label',`${this.labels.photo_number} ${i+1}`);button.setAttribute('aria-pressed',String(i===0));button.append(this.image(url,'',`${this.labels.photo_number} ${i+1}`));thumbs.append(button);});copy.append(thumbs);}
      if(review.reply){const reply=this.element('div','dsr__reply');reply.append(this.element('strong','',this.labels.reply),this.element('p','',review.reply));copy.append(reply);}
      const product=this.productLink(review,true);if(product)copy.append(product);content.append(copy);
      this.querySelector('[data-position]').textContent=`${index+1} / ${this.visibleReviews.length}`;this.querySelector('[data-prev]').disabled=index===0;this.querySelector('[data-next]').disabled=index===this.visibleReviews.length-1;this.dialog.scrollTop=0;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
